import { InputTypes, ValueTypes } from 'app/interfaces';


export default {
	key: 'branch_code',
	name: 'Filiale',
	inputType: InputTypes.DATASET_AUTOCOMPLETE,
	valueType: ValueTypes.REFERENCE,
	datasetCode: 'branches',
	remoteOptions: {
		limit: 100,
		getLabel(option): any{
			if(!option) return '';
			return '(' + option.code + ') ' + option.name;
		},
		getValue(option): any{
			if(!option) return;
			return option.code;
		},
	}
};
